export default __webpack_public_path__ + "static/media/040-shwedagon pagoda.f5a78fd8.svg";